module.exports = __webpack_public_path__ + "static/media/0-solution-0.e6246632.mp3";